import { Divider } from "antd";
import { campaignListingPage } from "grandus-lib/utils/fetches";

import dynamic from "next/dynamic";
const CampaignCard = dynamic(() =>
  import("components/campaign/card/CampaignCard")
);
const Pagination = dynamic(() =>
  import("components/pagination/PaginationBlog")
);

import styles from './index.page.module.scss';

const Campaigns = ({ campaigns, pagination }) => {
  return (
    <main className={`wrapper ${styles?.campaigns}`}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h1>Akcie</h1>
          </div>
        </div>
        <div className={`row ${styles?.listing}`}>
          {campaigns.map((campaign) => (
            <div className="col-12 col-md-6" key={`article-${campaign?.id}`}>
              <CampaignCard
                {...campaign}
                buttonElement={
                  <span
                    style={{ color: "#50237a", textDecoration: "underline" }}
                  >
                    Čítať viac...
                  </span>
                }
              />
            </div>
          ))}
        </div>

        {pagination?.pageCount > 1 ? (
          <div className="row">
            <div className="col-12">
              <Divider />
              <Pagination {...pagination} showSizeChanger={false} />
            </div>
          </div>
        ) : null}
      </div>
    </main>
  );
};

export async function getServerSideProps(context) {
  return campaignListingPage.serverSideProps(context);
}

export default Campaigns;
